import SubTitle from "../common/SubTitle";
import DashboardMapFilter from "../dashboard/DashboardMapFilter";
import { Box } from "@mui/material";
import MonitorSensors from "../vehicle/MonitorSensors";

export default function TrackAllStops({ isSchoolApp = false }) {
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
    ?.name;
  return (
    <>
      <SubTitle
        title={"Monitor Stops"}
        path={`${orgName || "organization"} > ${
          isSchoolApp ? "School Stops" : "Stops"
        } > Monitor Stops `}
      />
      <Box
        sx={{
          position: "relative",
          margin: { xs: "0px 20px 20px", md: "0px 40px 20px" },
          boxShadow: "-2px 1px 5px 1px #00000040",
          borderRadius: "10px",
          border: "1px solid #A5DCF3",
        }}
      >
        <MonitorSensors mode="stops" />
      </Box>
      <Box
        sx={{
          border: "none",
          position: "relative",
          margin: { xs: "0px 20px", md: "0px 40px" },
          boxShadow: "-2px 1px 5px 1px #00000040",
          borderRadius: "10px",
          border: "1px solid #A5DCF3",
        }}
      >
        <DashboardMapFilter filterBy="stops" />
      </Box>
    </>
  );
}
